import { useNavigate } from 'react-router-dom';
import type { TaskSession } from '@tailorcast/shared-types';
import { TaskStageBadge } from './TaskStageBadge';
import { TaskProgressBar } from './TaskProgressBar';

interface TaskListProps {
  sessions: TaskSession[];
}

export function TaskList({ sessions }: TaskListProps) {
  const navigate = useNavigate();

  if (sessions.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        No tasks yet. Create one to get started.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {sessions.map((task) => (
        <div
          key={task.id}
          onClick={() => navigate(`/tasks/${task.id}`)}
          className="card p-4 cursor-pointer hover:border-tailorcast-primary/30 transition-colors"
        >
          <div className="flex items-start justify-between mb-2">
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{task.goal}</p>
              <p className="text-xs text-gray-500 mt-0.5">
                {task.source} &middot; {new Date(task.createdAt).toLocaleDateString()}
              </p>
            </div>
            <TaskStageBadge stage={task.stage} />
          </div>
          {task.stage === 'executing' && task.totalSteps > 0 && (
            <TaskProgressBar currentStep={task.currentStep} totalSteps={task.totalSteps} />
          )}
        </div>
      ))}
    </div>
  );
}
